import React from 'react';
import ILoaderProps from '../../types/ILoaderProps';
import Spinner from '../spinner/Spinner';
import style from './loader.module.scss';
import RecaptchaDisclaimer from '../recaptcha/RecaptchaDisclaimer';
import { useTranslation } from 'react-i18next';
import ConditionalImage from '../app/ConditionalImage';
import { useAppState } from '../../hooks/zustandHooks';
import BackButton from '../buttons/BackButton';

const Loader: React.FC<ILoaderProps> = (props: ILoaderProps) => {
  const { display = false, framedLogo, logoText, logoUrl, spinnerText, showBackButton } = props;
  const showRecaptchaDisclaimer = useAppState(state => !state.appState.useValidationToken);
  const { t } = useTranslation();

  return display ? (
    <div className='px-6 pt-6 pb-32 sm:pb-6'>
      {showBackButton && <BackButton />}
      <div className={`${style.loader} justify-center sm:justify-start`} data-testid="loader">
        <h1>{logoText}</h1>
        {logoUrl && (
          <div className={framedLogo ? style.framedImage : style.image}>
            <ConditionalImage url={logoUrl} alt={logoText || ''} thresholdHeight={25} thresholdWidth={44} />
          </div>
        )}
        <div>
          <Spinner />
          <p className={style.fadeIn}>{t<string>(spinnerText || '')}</p>
          {showRecaptchaDisclaimer && (
            <div className={style.recaptcha}>
              <RecaptchaDisclaimer />
            </div>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default Loader;
